module.exports = __webpack_public_path__ + "static/media/0020.015634e8.jpg";